export default "__VITE_ASSET__BgrsRO4L__"